<app-list-template [templates]="templates$ | async" [loading]="loading$ | async" [stages]="stages$ | async"
    (templateSelected$)="navigateToTemplate($event)">
</app-list-template>